import { Urgency } from '../model/urgency';
import { Factory } from '@infodata-group/inf-commons';

export class UrgencyFactory implements Factory<Urgency> {
  build(o: any): Urgency {
    const urgency = new Urgency(o.id, o.label, o.priority);
    urgency.color = o.color.replace('#', '');
    urgency.iconTable = o.icon;
    return urgency;
  }

  getApi(): string {
    return 'urg';
  }
}
